import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { UserTagProfileData } from "@ServerTypes/accounts/accounts.schema";

interface UserTagEntry {
  isLoading: boolean;
  isLoaded: boolean;
  data: UserTagProfileData | null;
}

interface UserTagState {
  [userId: string]: UserTagEntry;
}

interface SetUserTagLoadingPayload {
  id: string;
}

interface SetUserTagDataPayload {
  id: string;
  data: UserTagProfileData;
}

const userTagSlice = createSlice({
  name: "userTagData",
  initialState: {} as UserTagState,
  reducers: {
    setUserTagLoading: (state: UserTagState, action: PayloadAction<SetUserTagLoadingPayload>) => {
      state[action.payload.id] = {
        isLoading: true,
        isLoaded: false,
        data: null,
      };
    },
    setUserTagData: (state: UserTagState, action: PayloadAction<SetUserTagDataPayload>) => {
      state[action.payload.id] = {
        isLoading: false,
        isLoaded: true,
        data: action.payload.data,
      };
    },
    setUpdatedUserProfileDetails: (state: UserTagState, action: PayloadAction<UserTagProfileData>) => {
      const payload = action.payload;
      const id = payload._id ?? payload.id;
      if (!id) return;
      state[id] = {
        isLoaded: true,
        isLoading: false,
        data: payload,
      };
    },
  },
});

export const { setUserTagLoading, setUserTagData, setUpdatedUserProfileDetails } = userTagSlice.actions;

export default userTagSlice.reducer;
